import { gql } from '@apollo/client'

export const REMOVE_FROM_PAYOUT_MUTATION = gql`
  mutation removeFromPayout($processingId: ID!) {
    removeFromPayout(processingId: $processingId) {
      id
    }
  }
`
